<template>
<div>

<!--
<b-button v-b-modal.modal-ag variant="primary" style="margin-top: 20px;"
@click="addClick()">
 Agregar nueva presentación
</b-button>
-->
<table class="table table-striped">

    <thead>

        <tr>

           <!--<th>ID</th>-->
            <th>

                Presentación
                
            </th>
            <th>Editar</th>

        </tr>

    </thead>

    <tbody>
        <tr v-for="(pre, index) in presentacion" :key="index">

            <!--<td>{{pre.PresentacionID}}</td>-->
            <td v-html="pre.Presentacion"></td>

            <td>
            <b-button v-b-modal.modal-ag variant="light"
            @click="editClick(pre)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                </svg>
            </b-button>
            <!--
            &nbsp;
            <b-button variant="light" @click="deleteClick(ref.ReferenciaID)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                </svg>
            </b-button>
            -->
            </td>

        </tr>
    </tbody>

</table>

<b-modal id="modal-ag" size="xl" hide-footer hide-header centered>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{modalTitle}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="$bvModal.hide('modal-ag')">
                </button>
            </div>

    <div class="modal-body">

        <div class="input-group">
            <span class="input-group-text">Presentación</span>
            <textarea class="form-control" v-model="Presentacion" aria-label="Presentacion" rows="20"></textarea>
        </div>
        &nbsp;
        <div>
            <!--
            <button type="button" @click="createClick()"
            v-if="ReferenciaID==0" class="btn btn-primary">
            Agregar
            </button>
            -->
            <button type="button" @click="updateClick()"
            v-if="PresentacionID!=0" class="btn btn-primary">
            Actualizar
            </button>
        </div>
    </div>
</b-modal>


</div>
</template>

<script>

import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';
import axios from 'axios';

export default {

    data(){

    return{
        user:'',
        presentacion:[],
        modalTitle:"",
        Presentacion:"",
        PresentacionID:0,
    }
    },

    created() {
        firebase.auth().onAuthStateChanged((user) => {
        if (user) {
            this.user = user;
        } else {
            this.$router.push('/admin')
        }
        });
    },
    
    methods:{
        refreshData(){
            axios.get("http://difraco.com.co:8000/presentacion")
            .then((response)=>{
                this.presentacion=response.data;
            })
        },

        addClick(){
            this.modalTitle="Agregar una presentación";
            this.PresentacionID=0;
            this.Presentacion="";
        },
        editClick(pre){
            this.modalTitle="Editar la presentación";
            this.PresentacionID=pre.PresentacionID;
            this.Presentacion=pre.Presentacion;
        },
        createClick(){
            axios.post("http://difraco.com.co:8000/presentacion",{
                Presentacion:this.Presentacion,
            })
            .then((response)=>{
                this.refreshData();
                alert(response.data);
            });
        },
        updateClick(){
            axios.put("http://difraco.com.co:8000/presentacion",{
                PresentacionID:this.PresentacionID,
                Presentacion:this.Presentacion,
            })
            .then((response)=>{
                this.refreshData();
                alert(response.data);
            });
        },
        deleteClick(id){
            if(!confirm("¿Está seguro de que quiere borrar?")){
                return;
            }
            axios.delete("http://difraco.com.co:8000/presentacion/"+id)
            .then((response)=>{
                this.refreshData();
                alert(response.data);
            });

        },
        
    },

    mounted:function(){
        this.refreshData();
    }

};
</script>
